import React, { FC } from "react";
import { useDispatch } from "react-redux";
import { Field, Form } from "core/hookForm";
import { Grid } from "@mui/material";

import { Button } from "ui-library/atoms";
import { Box, GridItem, GridLayout } from "ui-library/layouts";

import auth from "core/auth";
import i18n from "core/i18n";
import { useChangeTypeGetParamForm, useGetUserChangeTypesWithFormComponent, useHasRole } from "core/hooks";
import { fn } from "core/util";
import { Roles } from "enums";
import { ChangesWithFormComponentDefinition } from "types";

import { ERegistryInfoText } from "./containers";

export interface ContractChangesTabProps {
    changesDefinition: ChangesWithFormComponentDefinition;
}

export const ContractChangesTab: FC<ContractChangesTabProps> = ({ changesDefinition }) => {
    const { t } = i18n.useTranslation();
    const dispatch = useDispatch();
    const { form, changeType, onChange } = useChangeTypeGetParamForm();

    const isAuthenticated = useHasRole(Roles.AUTHENTICATED);
    const changeOptions = useGetUserChangeTypesWithFormComponent(changesDefinition);
    const selectedChange = fn.arrayFirst(changeOptions.filter((element) => element.code === changeType));

    const FormComponent = selectedChange ? selectedChange?.formComponent : () => null;

    return (
        <>
            <Grid>
                <GridItem xs={12}>
                    <ERegistryInfoText />
                </GridItem>

                <GridItem xs={12}>
                    <Form form={form} onSubmit={null} prompt={false}>
                        <Box fullWidth mb={3}>
                            <Field
                                input="select"
                                name="changeType"
                                placeholder={t("vehicle.change.type")}
                                label={t("vehicle.change.type")}
                                options={changeOptions}
                                onChange={onChange}
                            />
                        </Box>
                    </Form>
                    <FormComponent />
                </GridItem>

                {!isAuthenticated && !selectedChange && (
                    <GridItem xs={12} mt={4}>
                        <Button
                            variant="contained"
                            color="green"
                            onClick={() => dispatch(auth.logOut(auth.LogoutAction.REDIRECT_TO_E_REGISTRY))}
                        >
                            {t("change.tab.backToERegistry")}
                        </Button>
                    </GridItem>
                )}
            </Grid>
        </>
    );
};
